import RailsResource from "./rails-resource";

export default new class extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'locations',
      ajaxLoader: true
    });
  }
}